<template>
  <section class="intercom">
    <ServerPopup
      v-if="serverPopup.opened"
      v-model="serverPopup.modelValue"
      :mode="serverPopup.mode"
      @close="onServerPopupClose"
      @approve="onServerPopupApprove"
    />
    <Header class="intercom__header">
      <template v-slot:title>Настроить телеметрию</template>
    </Header>
    <div class="intercom__content">
      <component
        :is="activeTab"
        @addServer="onAddServer"
        @editServer="onEditServer"
      />
    </div>
  </section>
</template>

<script>
import Tabs from "Components/Tabs.vue";
import Header from "Components/Header.vue";
import UnitList from "Pages/AddMeterConfig/UnitList.vue";
import ServerList from "Pages/MeterConfig/ServerList.vue";
import ServerPopup from "Pages/Popup/Server.vue";
import MockServer from "Mixins/Mock/MockServer.js";

export default {
  name: "Units",
  mixins: [MockServer],
  components: { Tabs, UnitList, ServerList, Header, ServerPopup },
  data() {
    return {
      activeTab: "unitList",
    };
  },
  computed: {
    tabs() {
      return [
        {
          id: "unitList",
          label: "Адреса",
        },
        {
          id: "serverList",
          label: "Серверы",
        },
      ];
    },
  },
  watch: {
    serverPopup: {
      handler(value) {
        
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.intercom {
  width: 100%;

  &__header {
    margin: 0px $space-md $space-xxl;
  }

  &__tabs {
    margin: 0px $space-md $space-xl;
  }

  &__content {
    margin: 0px;
  }
}
</style>
